import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faTwitter, faLinkedin } from "@fortawesome/free-brands-svg-icons";

export default function Footer() {

  // SAME AS HEADER
  const footerLinkStyle = ({ isActive }) => `
    relative transition duration-300 w-fit
    ${isActive
      ? "text-primary"
      : "text-textMain dark:text-textDark"}
    after:content-[''] after:absolute after:left-0 after:-bottom-1
    after:h-[2px] after:w-0 after:bg-current
    after:transition-all after:duration-300
    after:rounded-full
    hover:after:w-full
    ${isActive ? "after:w-full" : ""}
  `;

  return (
    <div className="mt-32 pt-10 border-t border-borderLight dark:border-borderDark px-4 text-textMain dark:text-textDark bg-appBg dark:bg-appDark">

      {/* COPYRIGHT */}
      <p className="text-center mb-6 text-subText dark:text-subTextDark">
        © King Technology. All Rights Reserved.
      </p>

      {/* NAV LINKS */}
      <div className="flex justify-center gap-6 flex-wrap text-sm font-medium mb-6">

        <NavLink to="/" end className={footerLinkStyle}>Home</NavLink>
        <NavLink to="/about" className={footerLinkStyle}>About</NavLink>
        <NavLink to="/faq" className={footerLinkStyle}>FAQ</NavLink>
        <NavLink to="/blog" className={footerLinkStyle}>Blog</NavLink>
        <NavLink to="/contact" className={footerLinkStyle}>Contact</NavLink>
        <NavLink to="/privacy-policy" className={footerLinkStyle}>Privacy Policy</NavLink>
        <NavLink to="/terms" className={footerLinkStyle}>Terms</NavLink>
        <NavLink to="/disclaimer" className={footerLinkStyle}>Disclaimer</NavLink>

      </div>

      {/* SOCIAL ICONS */}
      <div className="flex justify-center gap-6 text-xl">

        {/* Instagram */}
        <a
          href="https://www.instagram.com/kingtech8001/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-subText dark:text-subTextDark hover:text-primary transition"
        >
          <FontAwesomeIcon icon={faInstagram} />
        </a>

        {/* Twitter / X */}
        <a
          href="https://x.com/KingTech8001"
          target="_blank"
          rel="noopener noreferrer"
          className="text-subText dark:text-subTextDark hover:text-primary transition"
        >
          <FontAwesomeIcon icon={faTwitter} />
        </a>

        {/* LinkedIn */}
        <a
          href="https://in.linkedin.com/company/king-technology-rajkot"
          target="_blank"
          rel="noopener noreferrer"
          className="text-subText dark:text-subTextDark hover:text-primary transition"
        >
          <FontAwesomeIcon icon={faLinkedin} />
        </a>

      </div>

    </div>
  );
}